// extracted by mini-css-extract-plugin
module.exports = {"button":"styles-module--button--2HX7C","button__disabled":"styles-module--button__disabled--3PcRg","spinner__wrapper":"styles-module--spinner__wrapper--1uoNV"};